<div class="alert mt-3 bg-{{alert.type}}" [@close]="!isAlertOpen ? 'closed' : 'open'">
    <button (click)="forceClose()" class="close ml-2" type="button">
        <i class="fa fa-times-circle"></i>
    </button>
    <span [ngSwitch]="alert.type">
        <i *ngSwitchCase="alertTypes.Error" class="fa fa-exclamation-circle"></i>
        <i *ngSwitchCase="alertTypes.Warning" class="fa fa-exclamation-circle"></i>
        <i *ngSwitchCase="alertTypes.Success" class="fa fa-check-circle"></i>
        <i *ngSwitchCase="alertTypes.Info" class="fa fa-info-circle"></i>
    </span>
    <span [innerHTML]="alert.message|sanitizeHtml"></span>
</div>
